import React from 'react';
import { ChevronRight } from 'lucide-react';

interface BreadcrumbNavProps {
  currentPath: string[];
  onNavigate: (path: string[]) => void;
}

export default function BreadcrumbNav({ currentPath, onNavigate }: BreadcrumbNavProps) {
  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-3">
        <li className="inline-flex items-center">
          <button
            onClick={() => onNavigate([])}
            className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600"
          >
            根目录
          </button>
        </li>
        {currentPath.map((item, index) => (
          <li key={index}>
            <div className="flex items-center">
              <ChevronRight className="w-4 h-4 text-gray-400" />
              <button
                onClick={() => onNavigate(currentPath.slice(0, index + 1))}
                className="ml-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ml-2"
              >
                {item}
              </button>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}